import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const Actions = crudActions('periods')

const updateQuarter = (ctx, data) => new Promise((resolve, reject) => {
  const params = {}
  if (data?.smsCode) {
    params.code = data.smsCode
  }
  axios.patch(`/quarter/${data.id}/`, { is_active: data.is_active }, { params })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})

export default {
  ...Actions,
  updateQuarter,
}
